import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { Caption, Caption2 } from '@components/styles/Typography';

const Size = () => {
    const { t } = useTranslation();

    return (
        <Table data-testid="size-table">
            <thead>
                <tr>
                    <th>
                        <Caption2>{t('sizeTableSizes')}</Caption2>
                    </th>
                    <th>
                        <Caption2>US</Caption2>
                    </th>
                    <th>
                        <Caption2>UK</Caption2>
                    </th>
                    <th>
                        <Caption2>EU</Caption2>
                    </th>
                    <th>
                        <Caption2>{t('sizeTableChest')}</Caption2>
                    </th>
                    <th>
                        <Caption2>{t('sizeTableWaist')}</Caption2>
                    </th>
                    <th>
                        <Caption2>{t('sizeTableHip')}</Caption2>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <Caption>XS</Caption>
                    </td>
                    <td>
                        <Caption>2</Caption>
                    </td>
                    <td>
                        <Caption>6</Caption>
                    </td>
                    <td>
                        <Caption>34</Caption>
                    </td>
                    <td>
                        <Caption>82</Caption>
                    </td>
                    <td>
                        <Caption>64</Caption>
                    </td>
                    <td>
                        <Caption>88</Caption>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Caption>S</Caption>
                    </td>
                    <td>
                        <Caption>4</Caption>
                    </td>
                    <td>
                        <Caption>8</Caption>
                    </td>
                    <td>
                        <Caption>36</Caption>
                    </td>
                    <td>
                        <Caption>86</Caption>
                    </td>
                    <td>
                        <Caption>68</Caption>
                    </td>
                    <td>
                        <Caption>92</Caption>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Caption>M</Caption>
                    </td>
                    <td>
                        <Caption>6</Caption>
                    </td>
                    <td>
                        <Caption>10</Caption>
                    </td>
                    <td>
                        <Caption>38</Caption>
                    </td>
                    <td>
                        <Caption>86</Caption>
                    </td>
                    <td>
                        <Caption>68</Caption>
                    </td>
                    <td>
                        <Caption>92</Caption>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Caption>L</Caption>
                    </td>
                    <td>
                        <Caption>8</Caption>
                    </td>
                    <td>
                        <Caption>12</Caption>
                    </td>
                    <td>
                        <Caption>40</Caption>
                    </td>
                    <td>
                        <Caption>94</Caption>
                    </td>
                    <td>
                        <Caption>76</Caption>
                    </td>
                    <td>
                        <Caption>100</Caption>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Caption>XL</Caption>
                    </td>
                    <td>
                        <Caption>10</Caption>
                    </td>
                    <td>
                        <Caption>14</Caption>
                    </td>
                    <td>
                        <Caption>42</Caption>
                    </td>
                    <td>
                        <Caption>98</Caption>
                    </td>
                    <td>
                        <Caption>80</Caption>
                    </td>
                    <td>
                        <Caption>104</Caption>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Caption>XXL</Caption>
                    </td>
                    <td>
                        <Caption>12</Caption>
                    </td>
                    <td>
                        <Caption>16</Caption>
                    </td>
                    <td>
                        <Caption>44</Caption>
                    </td>
                    <td>
                        <Caption>102</Caption>
                    </td>
                    <td>
                        <Caption>84</Caption>
                    </td>
                    <td>
                        <Caption>108</Caption>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Caption>XXXL</Caption>
                    </td>
                    <td>
                        <Caption>14</Caption>
                    </td>
                    <td>
                        <Caption>18</Caption>
                    </td>
                    <td>
                        <Caption>46</Caption>
                    </td>
                    <td>
                        <Caption>106</Caption>
                    </td>
                    <td>
                        <Caption>88</Caption>
                    </td>
                    <td>
                        <Caption>112</Caption>
                    </td>
                </tr>
            </tbody>
        </Table>
    );
};

const Table = styled.table`
    border-collapse: collapse;
    width: 80%;
    border-spacing: 2px;
    text-align: center;
    border-top: none;

    @media (max-width: 768px) {
        width: 100%;
    }

    th {
        padding: 8px 5px;
        background-color: ${({ theme }) => theme.colors.secondary};

        :first-child {
            padding-left: 15px;
        }
        :last-child {
            padding-right: 15px;
        }

        @media (max-width: 1024px) {
            padding: 0 5px 8px;
        }
    }

    tr {
        background-color: ${({ theme }) => theme.colors.secondary};

        :nth-child(odd) {
            background-color: ${({ theme }) => theme.colors.tertiaryVariant};
        }
    }

    td {
        height: 30px;
        padding: 7px 10px;
    }
`;

export default Size;
